export default __webpack_public_path__ + "static/GovernanceLayer-1669d85953eb72bf7311884e10a14621.png";